module.exports = __webpack_public_path__ + "img/cloud-upload.56d3ded9.png";